<div
    class="popular-bets-bet-builder-options__option_container"
    *rxFor="let option of options() | slice: 0 : visibleOptionsLimit(); let last = last; trackBy: trackOption">
    <ms-popular-bets-pod-event-logo
        [class.options-collapsed-connector]="last && shouldShowConnector()"
        [logoDetails]="option.logoDetails"
        [sportId]="event().sport.id" />
    <div class="popular-bets-bet-builder-options__option-name">{{ getSelectionInfo(option) }}</div>
</div>
